<template>
  <div class="pulsetask">
    <template v-if="!isLoading">
      <div class="pulsetask__title">
        <h2 class="medium-title">Ticket Manager</h2>
      </div>
      <div class="pulsetask__action">
        <div class="pulsetask__action__filters">
          <adx-dropdown-search 
            labelButton="Locations"
            :list="listLocation"
            :selected-value="selectedLocation"
            @selected="selectLocation" />
          <adx-dropdown-list
            ref="dropdownTeam"
            :labelButton="teamLabel"
            class="list-team"
            :list="listTeam"
            @selected="selectPerson"
            />
        </div>
      </div>
      <div v-if="tasks.length > 0" class="pulsetask__main">
        <table class="table-task">
          <tr>
            <th>Device</th>
            <th>Op. Hours Today</th>
            <th>Last Pulse</th>
            <th>Assigned To</th>
            <th></th>
          </tr>
          <tr v-for="task in tasks" :key="task.id">
            <td class="column-device">
              <div class="device">
                <div class="device-name strong subhead">{{ task.location }}</div>
                <div class="device-city-area subhead">{{ task.cluster }}, {{ task.city }}</div>
                <div class="device-version subhead">Version : {{ task.version }}</div>
                <div><span class="time-to-now subhead">{{ task.total_time_since_created }}</span></div>
              </div>
            </td>
            <td class="column-op-hour">
              <div class="op-hour">
                <div v-if="task.op_hour">
                  <span class="op-hour-start subhead">{{ task.op_hour.start }}</span>
                  -
                  <span class="op-hour-end subhead">{{ task.op_hour.end }}</span>
                </div>
              </div>
            </td>
            <td class="column-lastpulse">
              <div class="datetime subhead">{{ displayLastPulse(task.last_pulse) }}</div>
            </td>
            <td class="column-team">
              <adx-dropdown-select 
                class="dropdown-team" 
                :label="`Team`"
                :value.sync="task.assigned_to"
                :options="listAssignTo"
                :item-id="task.id"
                @selected="selectAssignee" />
            </td>
            <td class="column-action">
              <button class="primary btn-regular" @click.stop="toggleModal($event, task.id)">Close</button>
            </td>
          </tr>
        </table>
        <div class="pulsetask__main__cards">
          <div v-for="task in tasks" :key="task.id" class="pulsetask__main__cards__card">
            <div class="pulsetask__main__cards__card__location">
              <span class="card-title">Location</span>
              <span class="card-value">{{ task.location }}</span>
            </div>
            <div class="pulsetask__main__cards__card__city">
              <span class="card-title">City</span>
              <span class="card-value">{{ task.city }}</span>
            </div>
            <div class="pulsetask__main__cards__card__area">
              <span class="card-title">Area</span>
              <span class="card-value">{{ task.cluster }}</span>
            </div>
            <div class="pulsetask__main__cards__card__version">
              <span class="card-title">Version</span>
              <span class="card-value">{{ task.version }}</span>
            </div>
            <div class="pulsetask__main__cards__card__op_hour">
              <span class="card-title">Op. Hour</span>
              <span v-if="task.op_hour" class="card-value">
                <span>{{ task.op_hour.start }}</span>
                 - 
                <span>{{ task.op_hour.end }}</span>
              </span>
              <span v-else class="card-value"></span>
            </div>
            <div class="pulsetask__main__cards__card__lastpulse">
              <span class="card-title">Last Pulse</span>
              <span class="card-value">
                <span>{{ displayLastPulse(task.last_pulse) }}</span>
                <span class="time-to-now">{{ task.total_time_since_created }}</span>
              </span>
            </div>
            <div class="pulsetask__main__cards__card__action">
              <adx-dropdown-select 
                class="dropdown-team" 
                :label="`Team`"
                :value.sync="task.assigned_to"
                :options="listAssignTo"
                :item-id="task.id"
                @selected="selectAssignee" />
              <button class="btn-regular primary btn-close-task" @click.stop="toggleModal($event, task.id)">
                close
              </button>
            </div>
          </div>
        </div>
      </div>
      <adx-empty v-if="tasks.length == 0" />
      <div class="pulsetask__pagination">
        <adx-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage" />
      </div>
    </template>
    <div class="pulsetask__loading">
      <adx-loading v-if="isLoading" />
    </div>
    <adx-modal 
      v-if="showModal"
      class="modal-psr"
      @modal-close="toggleModal"
      title="Task Description"
    >
      <div slot="content" class="content">
        <div class="content__problem">
          <adx-textarea 
            label="Problem detail"
            :value.sync="problem"
            :validation="['NotEmpty']"
            inputId="problem"
          />
        </div>
        <div class="content__root-cause">
          <adx-textarea 
            label="Root cause"
            :value.sync="rootCause"
            :validation="['NotEmpty']"
            inputId="rootCause"
          />
        </div>
        <div class="content__solution">
          <adx-textarea 
            label="Solution"
            :value.sync="solution"
            :validation="['NotEmpty']"
            inputId="solution"
          />
        </div>
        <div class="content__psr_action">
          <button type="button" class="secondary btn-regular btn-cancel-modal" @click.stop="toggleModal">Cancel</button>
          <button type="button" class="primary btn-regular" @click.stop="updateTask(taskOnModal)">Save</button>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import moment from 'moment'
import Modal from '@/components/Modal'
import TextArea from '@/components/Form/TextArea'
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import DropdownSort from '@/components/Form/SelectDropdown'
import SelectDropdown from '@/components/Form/SelectDropdown'
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import Empty from '@/components/NotFound/Selection'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { helpers } from '@/lib/validation/'
import { mapGetters } from 'vuex'

export default {
  name: 'adx-pulse-task',
  components: {
    'adx-modal': Modal,
    'adx-textarea': TextArea,
    'adx-dropdown-search': DropdownSearch,
    'adx-dropdown-list': ListDropdown,
    'adx-dropdown-sort': DropdownSort,
    'adx-dropdown-select': SelectDropdown,
    'adx-pagination': Pagination,
    'adx-loading': Loading,
    'adx-empty': Empty
  },
  props: {

  },
  data() {
    return {
      tasks: [],
      searchText: '',
      selectedPage: 1,
      maxPage: 1,
      isLoading: true,
      listTeam: [],
      listLocation: [],
      teamLabel: 'Assignee',
      listAssignTo: [],
      sortingList: [
        {
          'id': 1,
          'label': 'First Added',
          'value': 'created'
        },
      ],
      selectedSortValue: 'created',
      selectedPerson: null,
      selectedTask: {},
      showModal: false,
      taskOnModal: null,
      problem: '',
      rootCause: '',
      solution: '',
      selectedLocation: '',
      param: {page: 1}
    }
  },
  computed: {
    ...mapGetters({
      profile: 'profile'
    })
  },
  watch: {
    searchText: helpers.debounce(function () {
      this.$nextTick(function () {
        this.selectedPage = 1
        this.getTask()
      })
    }, 500),
    listTeam(newValue, oldValue) {
      let email = this.$route.query.email || this.profile.email
      if (email) {
        newValue.forEach((person) => {
          if (person.label == email) {
            this.selectedPerson = email
            this.teamLabel = email
          }
        })
      }
    }
  },
  beforeCreate() {
    
  },
  created() {
    let query = Object.keys(this.$route.query)
    query.map((key) => {
      this.param[key] = this.$route.query[key]
      if (key == 'location') {
        this.selectedLocation = this.$route.query[key].toString()
      }
      if (key == 'email') {
        this.selectedPerson = this.$route.query[key]
      }
      if (key == 'page') {
        this.selectedPage = parseInt(this.$route.query[key])
      }
    })
    this.getTeam()
    this.getLocations()
  },
  beforeMount() {

  },
  mounted() {
    this.$nextTick(function() {
      this.getTask()
    })
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getTask() {
      (async () => {
        this.isLoading = true

        const response = await api.get(apiV2.getPulseTask, {params: this.param, needToken: true})
        if (response.status == 200) {
          this.tasks = response.data.results
          this.maxPage = response.data.max_page
          this.isLoading = false
        }
      })();
    },
    updateTask(id) {
      (async () => {
        if (this.validate()) {
          // status code.
          // 2 = closed, 1 = open
          // if current status open/1, send status closed/2 to close.
          let data = {
            id: id, 
            status:2,
            problem: this.problem,
            root_cause: this.rootCause,
            solution: this.solution
          }
          const response = await api.patch(apiV2.updatePulseTask, data, {needToken: true})
          if (response.status == 200) {
            this.$notify({
              group: 'saved',
              title: 'Success',
              text: `Task successfully closed`,
              type: 'success'
            });
            this.getTask()
            this.toggleModal()
          } else {
            let data = response.data
            this.$notify({
              group: 'saved',
              title: 'Failed',
              text: `Task failed to be closed. ${data.detail}`,
              type: 'danger'
            });
          }
        }
      })();
    },
    assignTask(assignee) {
      (async () => {
        let data = {
          id: this.selectedTask,
          assign_to: assignee.id
        }
        const response = await api.patch(apiV2.assignTask, data, {needToken: true})
        if (response.status == 200) {
          this.$notify({
            group: 'saved',
            title: 'Success',
            text: `Task successfully assigned to ${assignee.label}`,
            type: 'success'
          });
        } else {
          let data = response.data
          this.$notify({
            group: 'saved',
            title: 'Failed',
            text: `Task failed to be assigned. ${data.detail}`,
            type: 'danger'
          });
        }
      })();
    },
    getLocations() {
      (async () => {
        const response = await api.get(apiV2.locationTask, {needToken: true})
        if (response.status == 200) {
          this.listLocation = response.data
        }
      })();
    },
    selectLocation(item) {
      this.selectedLocation = item.id.toString()
      this.setUrl()
      this.getTask()
    },
    getTeam() {
      (async () => {
        const response = await api.get(apiV2.getTeamOps, {needToken: true})
        if (response.status == 200) {
          this.mapTeam(response.data)
        }
      })();
    },
    validate() {
      let problem = document.getElementById('problem')
      let rootCause = document.getElementById('rootCause')
      let solution = document.getElementById('solution')
      if (!problem.value) {
        problem.focus()
        problem.blur()

        return false
      }
      if (!rootCause.value) {
        rootCause.focus()
        rootCause.blur()

        return false
      }
      if (!solution.value) {
        solution.focus()
        solution.blur()

        return false
      }

      this.problem = problem.value
      this.rootCause = rootCause.value
      this.solution = solution.value

      return true
    },
    mapTeam(data) {
      let listTeam = this.listTeam
      let listAssignTo = this.listAssignTo
      data.forEach((person) => {
        listTeam.push({ id: person.id, label: person.email, value: person.email })
        listAssignTo.push({ id: person.id, label: person.email, value: person.email })
      })
      this.listAssignTo = listAssignTo
      this.listTeam = listTeam
      this.listTeam.unshift({id: 9999, value: 'Unassigned', label: 'Unassigned'})
      this.listTeam.unshift({id: 0, value: 'All', label: 'All'})
    },
    selectPerson(item) {
      this.selectedPerson = item.value
      this.teamLabel = item.id == 0 ? 'All' : item.value
      this.setUrl()
      this.getTask()
    },
    selectAssignee(item) {
      this.selectedTask = item.id
      this.assignTask(item.item)
    },
    displayLastPulse(timestamp) {
      if (!timestamp) return '-'
      let datetime = moment(timestamp, 'YYYY-MM-DDTHH:mm:ss.SSSSZ')
      return datetime.format('DD MMM YYYY, HH:mm')
    },
    focusSearch() {
      this.$refs.search.focus()
    },
    selectPage(page) {
      this.selectedPage = page
      this.setUrl()
      this.getTask()
    },
    toggleModal(event, taskId) {
      this.showModal = !this.showModal
      if (!this.showModal) {
        this.resetPSRForm()
      }
      this.taskOnModal = this.showModal ? taskId : null
    },
    resetPSRForm() {
      this.problem = ''
      this.rootCause = ''
      this.solution = ''
    },
    setUrl() {
      this.param = {}
      this.param.page = this.selectedPage
      if (this.selectedPerson) {
        this.param.email = this.selectedPerson
      } 
      if (this.selectedLocation) {
        this.param.location = this.selectedLocation
      }
      this.$router.replace({
        query: this.param
      })
    },
    prepareDefaultFilter() {
      this.listTeam.forEach((person) => {
        if (person.label == this.profile.email) {
          this.$$refs.dropdownTeam.select(person)
        } 
      })
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
.pulsetask {
  .dropdown-team {
    .popup {
      width: auto;
    }
  }
}
</style>
